<template>
    <div class="tune-chatbot">
        <div class="left">
            <div class="tune-header">Tune your chatbot</div>
            <div class="tune-desc">Add final tweaks to achieve better results.</div>
            <div class="welcome-box tune-box">
                <div class="tune-header">
                    <div>Customize your welcome message</div>
                </div>
                <div class="input-box input-welcome-text">
                    <textarea v-model="clone.welcomeText" />
                </div>
            </div>
            <div class="attributes-box tune-box">
                <div class="tune-header">
                    <div>Set up attributes</div>
                </div>
                <div class="input-box" v-for="field of fields" :key="field.key">
                    <div class="title-box">
                        <div class="icon">
                            <i class="material-icons done">check</i>
                            <i class="material-icons edit">edit</i>
                        </div>
                        <div class="text">{{ field.label }}</div>
                    </div>
                    <div class="value-box">
                        <input placeholder="Attribute value" v-model="clone.attributes[field.key]" />
                    </div>
                </div>
            </div>
        </div>
        <div class="right">
            <ChatbotTunePreview :company-name="clone.attributes.company_name" :welcome-text="clone.welcomeText" />
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import ChatbotTunePreview from "./ChatbotTunePreview.vue";
import _ from "lodash";
import { sendSocketMessage } from "../../../../../utils/socketStream";
import { mapState } from "vuex";

export default Vue.extend({
    name: "TuneChatbot",
    components: { ChatbotTunePreview },
    props: {
        value: {
            type: Object,
            default: () => ({
                attributes: [],
                welcomeText: "",
                enabledButtons: [],
            }),
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            fields: [
                { key: "company_name", label: "Company Name" },
                { key: "company_about_us", label: "About us" },
                { key: "company_email", label: "Email" },
                { key: "company_phone", label: "Phone" },
                { key: "company_address", label: "Company Address" },
                { key: "instagram_url", label: "Instagram" },
                { key: "youtube_url", label: "Youtube" },
                { key: "linkedin_url", label: "Linkedin" },
                { key: "facebook_url", label: "Facebook" },
                { key: "twitter_url", label: "Twitter" },
                { key: "privacy_url", label: "Privacy (URL)" },
                { key: "pricing_url", label: "Pricing (URL)" },
            ],
        };
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site._id,
            userId: (state) => state.auth.user?._id,
        }),
    },
    methods: {},
    watch: {
        clone: {
            handler: function (val, oldVal) {
                this.$emit("input", val);
            },
            deep: true,
        },
        value: {
            handler: function (val, oldVal) {
                const isEquals = _.isEqual(val, this.clone);
                if (!isEquals) {
                    this.clone = _.cloneDeep(val);
                }
            },
            deep: true,
        },
    },
});
</script>

<style scoped lang="scss">
.tune-chatbot {
    display: flex;
    flex-direction: row;
    gap: 20px;

    .left {
        display: flex;
        flex-direction: column;
        gap: 10px;
        max-width: 100%;
        width: 550px;

        .tune-header {
            color: #22272d;
            cursor: pointer;
            font-size: 30px;
            font-weight: 700;
            line-height: 38px;
            margin-bottom: 10px;
        }

        .tune-desc {
            color: #22272d;
            font-size: 18px;
            line-height: 23px;
        }

        .tune-box {
            display: flex;
            position: relative;
            flex-direction: column;
            max-height: 100%;
            min-height: 25px;
            overflow: hidden;
            padding: 14px 0;
            width: 100%;

            .tune-header {
                font-size: 16px;
                font-weight: 600;
                line-height: 20px;
            }

            .input-box {
                display: flex;
                align-items: center;
                background: #f5f5f5;
                border: 1px solid transparent;
                border-radius: 8px;
                justify-content: flex-start;
                margin-bottom: 14px;

                textarea {
                    background-color: transparent;
                    border: 0;
                    color: #22272d;
                    display: block;
                    font-family: Source Sans Pro, sans-serif;
                    font-size: 16px;
                    height: 52px;
                    line-height: 20px;
                    margin: 15px;
                    padding: 0;
                    resize: none;
                    width: 100%;
                }

                &:hover {
                    background-color: #ededed;
                    cursor: pointer;

                    .icon {
                        .edit {
                            display: block !important;
                        }

                        .done {
                            display: none !important;
                        }
                    }
                }

                .title-box {
                    display: flex;
                    align-items: center;
                    max-width: 250px;
                    min-width: 170px;
                    padding: 15px;
                    white-space: nowrap;

                    .text {
                        color: #22272d;
                        font-weight: 600;
                        opacity: 0.6;
                    }

                    .icon {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-right: 10px;
                        max-width: 22px;
                        min-width: 22px;
                        overflow: hidden;
                        width: 22px;

                        .done {
                            display: flex;
                            align-items: center;
                            background: #006cff;
                            border-radius: 100%;
                            color: #fff;
                            font-size: 10px;
                            justify-content: center;
                            min-height: 18px;
                            min-width: 18px;
                        }

                        .edit {
                            color: #22272d;
                            display: none;
                            font-size: 16px;
                        }
                    }
                }

                .value-box {
                    display: flex;
                    align-items: center;
                    height: 100%;
                    margin-right: 15px;
                    max-width: 100%;
                    min-width: 50px;
                    width: 100%;

                    input {
                        -webkit-appearance: none;
                        background: transparent;
                        border: 0;
                        color: #22272d;
                        font-size: 16px;
                        font-weight: 600;
                        height: 100%;
                        line-height: 20px;
                        margin: 0;
                        width: 100%;
                    }
                }
            }

            &.welcome-box {
                margin-top: 14px;
            }
        }
    }
}
</style>
